import { Review as ReviewInterface } from "../../others/review.interfaces"
import Review from "../reviews/Review";

interface ReviewSectionProps {
    reviews: ReviewInterface[] | undefined;
}

const ReviewSection = ({ reviews }: ReviewSectionProps): JSX.Element => {
    return (
        <div>
            <h3>Reviews</h3>
            <div className="flex flex-col gap-3">
                {
                    reviews?.map((review, i) => {
                        return <Review {...review} key={'Review-' + i} small={true} />
                    })
                }
            </div>
        </div>
    )
}

export default ReviewSection